import React from 'react';
import { Cake } from 'lucide-react';
interface Birthday {
  id: number;
  name: string;
  date: string; // Format: MM-DD
  age?: number;
}
export function BirthdaysWidget() {
  // Mock data - birthdays sorted by month
  const birthdays: Birthday[] = [{
    id: 1,
    name: 'Marie Dupont',
    date: '01-15',
    age: 32
  }, {
    id: 2,
    name: 'Jean Martin',
    date: '03-22',
    age: 45
  }, {
    id: 3,
    name: 'Sophie Bernard',
    date: '03-28',
    age: 29
  }, {
    id: 4,
    name: 'Thomas Petit',
    date: '06-10',
    age: 35
  }, {
    id: 5,
    name: 'Camille Roux',
    date: '09-05',
    age: 27
  }, {
    id: 6,
    name: 'Lucas Moreau',
    date: '11-18',
    age: 41
  }, {
    id: 7,
    name: 'Emma Dubois',
    date: '12-03',
    age: 33
  }];
  const monthNames = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
  // Group birthdays by month
  const birthdaysByMonth = birthdays.reduce((acc, birthday) => {
    const month = parseInt(birthday.date.split('-')[0]) - 1;
    if (!acc[month]) {
      acc[month] = [];
    }
    acc[month].push(birthday);
    return acc;
  }, {} as Record<number, Birthday[]>);
  // Get current month for highlighting
  const currentMonth = new Date().getMonth();
  return <div className="bg-white rounded-lg shadow-sm p-5 min-h-[400px] flex flex-col" data-id="element-1882">
      <div className="flex items-center justify-between mb-4" data-id="element-1883">
        <h3 className="font-semibold text-gray-900" data-id="element-1884">Anniversaires</h3>
        <Cake className="h-5 w-5 text-blue-600" data-id="element-1885" />
      </div>

      <div className="flex-1 overflow-y-auto space-y-4" data-id="element-1886">
        {Object.entries(birthdaysByMonth).sort(([monthA], [monthB]) => parseInt(monthA) - parseInt(monthB)).map(([month, monthBirthdays]) => {
        const monthIndex = parseInt(month);
        const isCurrentMonth = monthIndex === currentMonth;
        return <div key={month} className={`${isCurrentMonth ? 'bg-blue-50 -mx-2 px-2 py-2 rounded-lg' : ''}`} data-id="element-1887">
                <h4 className={`text-sm font-semibold mb-2 ${isCurrentMonth ? 'text-blue-900' : 'text-gray-700'}`} data-id="element-1888">
                  {monthNames[monthIndex]}
                  {isCurrentMonth && <span className="ml-2 text-xs px-2 py-0.5 bg-blue-200 text-blue-800 rounded-full" data-id="element-1889">
                      Ce mois
                    </span>}
                </h4>
                <div className="space-y-2" data-id="element-1890">
                  {monthBirthdays.map(birthday => {
              const day = birthday.date.split('-')[1];
              return <div key={birthday.id} className="flex items-center justify-between py-1" data-id="element-1891">
                        <div className="flex items-center gap-2" data-id="element-1892">
                          <div className="h-8 w-8 rounded-full bg-purple-100 flex items-center justify-center" data-id="element-1893">
                            <Cake className="h-4 w-4 text-purple-600" data-id="element-1894" />
                          </div>
                          <div data-id="element-1895">
                            <p className="text-sm font-medium text-gray-900" data-id="element-1896">
                              {birthday.name}
                            </p>
                            <p className="text-xs text-gray-500" data-id="element-1897">
                              {day} {monthNames[monthIndex]}
                            </p>
                          </div>
                        </div>
                        {birthday.age && <span className="text-xs text-gray-500" data-id="element-1898">
                            {birthday.age} ans
                          </span>}
                      </div>;
            })}
                </div>
              </div>;
      })}
      </div>

      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-1899">
        <p className="text-xs text-gray-500 text-center" data-id="element-1900">
          {birthdays.length} anniversaires cette année
        </p>
      </div>
    </div>;
}